import {useCallback} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {useToast, useUserApp} from "@hooks";
import {monitoringResultsReportFormSubmittedFilters} from "../@signals";


export default function useMonitoringResultsCustomReports() {
	const { showToast } = useToast()
	const { userEmail, userCustomer } = useUserApp()

	const nameReport = useSignal('')
	const frequency = useSignal(null)
	const emailsReport = useSignal([userEmail])

	const resetFormData = useCallback(() => {
		nameReport.value = ''
		frequency.value = null
		emailsReport.value = [userEmail]
	}, [userEmail])

	const handleSendToBack = () => {
		let apiUrl =`${WEBBACK_V2_API}/reports/create`

		if (frequency.value === 'now') {
			apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
		}

		showToast.promise(postSubmit(apiUrl, {
			nameReport: nameReport.value,
			frequency: frequency.value,
			emailsReport: emailsReport.value.join(","),
			reportType: 'monitoringResults',
			filters: {
				id_customer: userCustomer,
				metric: monitoringResultsReportFormSubmittedFilters.value.metric,
				country: monitoringResultsReportFormSubmittedFilters.value.country,
				retailer: monitoringResultsReportFormSubmittedFilters.value.retailer,
				brand: monitoringResultsReportFormSubmittedFilters.value.brand,
				skuGroup: monitoringResultsReportFormSubmittedFilters.value.skuGroup,
				sku: monitoringResultsReportFormSubmittedFilters.value.sku
			}
		}), {
			error: 'Error: Please try again later.',
			success: `Report successfully created.`,
		})
	}

	return {
		resetFormData,
		handleSendToBack,
		nameReport,
		frequency,
		emailsReport
	}
}